import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

const BrokerLabel = ({ label, required }) => (
  <label className="d-flex align-items-center">
    {label}
    {required && <span>*</span>}
    <OverlayTrigger
      overlay={brokerTooltip()}
      placement="top"
    >
      <FontAwesomeIcon className="ml-2" icon={faCircleInfo} size="lg"/>
    </OverlayTrigger>
  </label>
);

export default BrokerLabel;

const brokerTooltip = props => (
  <Tooltip id="primary-broker-tooltip" {...props}>
    You must include yourself or a broker you have permissions for to create this property
  </Tooltip>
);

BrokerLabel.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool
};
